//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vipEquity from './vipEquity.vue';
export default {
    components: { vipEquity },
    mixins: [],
    data() {
        return {
            isResult: false,
            accountNumber: '', // 查询帐号
            currentUserInfo: {
                // 用户信息
                accountId: '', //用户id
                displayName: '', // 用户名
                expireTime: '', // 到期时间
                queryTime: '', // 查询时间
                username: '' // 手机号
            },
            careObjectList: [] // 已守护长者
        };
    },
    watch: {
        $route() {
            // 此处写router变化时，想要初始化或者是执行的方法......
            this.getUserInfoByPhoneNum();
        }
    },
    methods: {
        // 查询用户信息通过手机号
        getUserInfoByPhoneNum() {
            let that = this;
            if (!that.accountNumber) {
                that.$vux.toast.text('请输入要查询的账号');
                return false;
            }
            if (!that.isPoneAvailable(that.accountNumber)) {
                that.$vux.toast.text('手机号格式不正确');
                return false;
            }
            that.$axios
                .get('/api/v1.0/familyApp/vip/wechat/account', {
                    params: {
                        phoneNum: that.accountNumber
                    }
                })
                .then(function(response) {
                    console.log('获取用户信息：' + response);
                    that.currentUserInfo = response.body.account;
                    let tmp = Date.parse(new Date()).toString();
                    tmp = tmp.substr(0, 10);
                    that.currentUserInfo.queryTime = tmp;
                    that.careObjectList = response.body.careObjectList;
                    that.isResult = true;
                });
        },
        // 去会员充值页面
        goMemberRechargePage() {
            let memberInfo = {
                currentUserInfo: this.currentUserInfo,
                careObjectList: this.careObjectList
            };
            this.$store.state.memberInfo = memberInfo;
            this.$router.push('/memberRecharge');
        },
        // 判断是否为手机号
        isPoneAvailable: function(pone) {
            var myreg = /^1[34578]\d{9}$/;
            if (!myreg.test(pone)) {
                return false;
            } else {
                return true;
            }
        },
        // 时间戳格式化
        timestampToTime(value) {
            if (value && value != '0') {
                return this.$moment(value * 1000).format('YYYY-MM-DD HH:mm');
            }
        },
        //获取微信配置
        getWeiXinConfig(callback, url_) {
            let that = this;
            that.$axios
                .get('/api/v1.0/weChatPublicSignature', {
                    params: {
                        url: url_
                    }
                })
                .then(function(response) {
                    if (response.status == 200) {
                        var weiXinConfig = response.body;
                        callback && callback(weiXinConfig);
                    }
                });
        },
        weixinLogin() {
            let that = this;
            if (that.$store.state.token) {
                this.getUserInfo(10);
            } else {
                var params = that.$queryUrlParams(window.location.href);
                if (params && params.code) {
                    console.log('微信授权登录后的回调处理' + params.code);
                    that.$axios
                        .get('/api/v1.0/weChatLogin', {
                            params: {
                                code: params.code
                            }
                        })
                        .then(function(response) {
                            if (response.status == 200) {
                                that.$store.state.token = response.body;
                                that.getUserInfo(10);
                                if (sessionStorage.wxRedirectPath) {
                                    that.$router.push(sessionStorage.wxRedirectPath);
                                }
                            }
                        });
                }
            }
        },
        //获取用户信息
        getUserInfo(accountType) {
            let that = this;
            that.$axios
                .get('/api/v1.0/lonbonShop/userInfo', {
                    params: {
                        accountType: accountType
                    }
                })
                .then(function(response) {
                    if (response.status == 200) {
                        var user = response.body;
                        var userInfo = {
                            poster: that.dealHeadImage(user.headImage),
                            displayName: user.displayName,
                            shopperId: user.shopperId,
                            accountId: user.accountId
                        };
                        that.$store.state.userInfo = userInfo;
                    }
                });
        }
    },
    mounted() {
        document.title = '会员查询';
        if (this.$isWeixin()) {
            var params = this.$queryUrlParams(window.location.href);
            if (params && params.code) {
                this.weixinLogin();
            } else {
                let that = this;
                that.getWeiXinConfig(function(weiXinConfig) {
                    var redirect_uri = encodeURIComponent(sessionStorage.domainURL + '/LonBonStore/#/memberInquiry');
                    sessionStorage.wxRedirectPath = that.$route.fullPath;
                    var url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${weiXinConfig.appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`;
                    window.location.href = url;
                }, '');
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/member/memberInquiry.vue